<ng-container [ngTemplateOutlet]="template" />

<ng-template #visualization>
  @switch (getComponentVisualizationType()) {
    @case (VisualizationType.Summary) {
      <reports-dashboards-summary
        [data]="$any(data())"
        [component]="component()"
        [fullscreenEnabled]="fullscreenEnabled()"
        [currColWidth]="currColWidth()"
        [resourcesPreviewAvailable]="resourcesPreviewAvailable()"
        [animated]="!export()"
        (openResources)="openResourcesFromSummaryItem($event)"
      />
    }

    @case (VisualizationType.PivotTable) {
      <reports-dashboards-pivot-table
        [data]="$any(data())"
        [component]="component()"
        [fullscreenEnabled]="fullscreenEnabled()"
        [resourcesPreviewAvailable]="resourcesPreviewAvailable()"
        [isExport]="export()"
        (openResourceAt)="openResourcesAt($event)"
        (tableSortChange)="handleSortChange($event)"
      />
    }

    @case (VisualizationType.Table) {
      <reports-dashboards-table
        [data]="$any(data())"
        [component]="component()"
        [resourcesPreviewAvailable]="resourcesPreviewAvailable()"
        [paginate]="paginateTable()"
        [isExport]="export()"
        (openResourceAt)="openResourcesAt($event)"
        (tableSortChange)="handleSortChange($event)"
      />
    }

    @case (VisualizationType.Chart) {
      <reports-legacy-chart
        [component]="component()"
        [export]="export()"
        [data]="$any(data())"
        [resourcesPreviewAvailable]="resourcesPreviewAvailable()"
        [theme]="(theme$ | async)!"
        (openResourceAt)="openResourcesAt($event)"
        (rendered)="rendered.emit()"
      />
    }

    @default {
      <div style="overflow: auto; width: 100%; height: 100%">
        <pre style="display: block">
            {{ component() | json }}
          </pre
        >
        <pre style="display: block">
            {{ data() | json }}
          </pre
        >
      </div>
    }
  }
</ng-template>

<ng-template #empty>
  <div class="empty-state-container">
    <rt-empty-state
      [icon]="'chart-bar-broken'"
      [desc]="'tlr.grid_component.empty_state_title' | translate"
      [class.too-small]="component().grid.cols <= 3"
      variant="small v-centered"
      class="empty-state-component"
    />
  </div>
</ng-template>

<ng-template #failed>
  <reports-failed-empty-state
    [reason]="visualizationDisabled() ?? component().unavailableReason"
    [small]="component().grid.cols <= 2 || component().grid.rows <= 1"
    [allowRefreshing]="allowRefreshing()"
    (refresh)="refresh.emit()"
  />
</ng-template>
